// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UbTCVSTUdDX14i {
  color: var(--ds-text-subtlest, #626f86);
}
.RFRWM4XiXjiPnk {
  display: block;
  max-width: 600px;
  margin: 75px auto;
  text-align: center;
}
.RFRWM4XiXjiPnk h1 {
  margin-bottom: 24px;
  font-size: 26px;
}
.RFRWM4XiXjiPnk p {
  font-size: 18px;
  line-height: 22px;
}
.RFRWM4XiXjiPnk.LpY6Z7YV3WAyIc {
  margin-top: 35px;
}
.RFRWM4XiXjiPnk.LpY6Z7YV3WAyIc h1 {
  margin-top: 20px;
}
.TsVLX7ZzB8MTtJ {
  margin-top: 32px;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
}
.TsVLX7ZzB8MTtJ a {
  color: var(--ds-link, #0c66e4);
}
.gYbGps3Md7awM3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: var(--ds-space-400, 32px);
  gap: var(--ds-space-150, 12px);
}
.gYbGps3Md7awM3 button {
  min-width: 200px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quiet": `UbTCVSTUdDX14i`,
	"bigMessage": `RFRWM4XiXjiPnk`,
	"withPicture": `LpY6Z7YV3WAyIc`,
	"littleMessage": `TsVLX7ZzB8MTtJ`,
	"ctaContainer": `gYbGps3Md7awM3`
};
export default ___CSS_LOADER_EXPORT___;
